import SocialFollow from '../SocialMedia';
import FooterMenuContainer from './FooterMenus/FooterMenuContainer';
import FooterInfo from './FooterInfo';
import { FOOTER_DATA } from '../../constants';

const Footer = () => (
  <footer className="footer">
    <div className="footer__wrapper">
      <div className="footer__row footer__row--top">
        <div className="footer__wrapper footer__wrapper--top">
          <SocialFollow />
        </div>
      </div>
      <FooterMenuContainer footerMenus={FOOTER_DATA.MENUS} />
      <FooterInfo copyright={FOOTER_DATA.COPYRIGHT_LINE_1} />
      <FooterInfo copyright={FOOTER_DATA.COPYRIGHT_LINE_2} />
    </div>
  </footer>
);

export default Footer;
